import React, { Component } from 'react'
import './../../router/router.css';

class Demo extends Component {
    render() {
        return (
            <div className="welcome">
                  欢迎使用管理控制台
            </div> 
        );
    }
}

export default Demo;